import React from 'react';
import YouTubeVideo from './YouTubeVideo';
import VimeoVideo from './VimeoVideo';
import FacebookVideo from './FacebookVideo';
import RumbleVideo from './RumbleVideo';
import FaithlifeTvVideo from './FaithlifeTvVideo';
import Player from './Player';

export default function VideoFileGlobalPlayer({file, width, height}) {
  let player;
  if (file.get('location') === 'youtube'){
    height = height ?? 'calc(45vw)';
    width = width ?? 'calc(80vw)';
    player = <YouTubeVideo src={file.get('remote_file')} width={width} height={height} maxWidth={1066} />;
  } else if (file.get('location') === 'vimeo'){
    player = <VimeoVideo file={file} />;
  } else if (file.get('location') === 'facebook'){
    player = <FacebookVideo file={file} />;
  } else if (file.get('location') === 'rumble'){
    player = <RumbleVideo src={file.get('remote_file')} />;
  } else if (file.get('location') === 'faithlife_tv'){
    player = <FaithlifeTvVideo file={file} />;
  } else {
    console.log('AUTO PLAY: ', FW.store.get('site').prop('auto_play_videos'));
    player = <Player autoPlay={FW.store.get('site').prop('auto_play_videos')} sources={file.helper.jwPlayerSources} thumbnailSrc={file.helper.thumbnailUrl(2880)} />;
  }

  console.log('PLAYER: ', player);

  return player;
}
